import uniqBy from 'lodash/uniqBy'

import { defaultSelectedTab } from '../../constants/constants'
import { createSlice } from '@reduxjs/toolkit'
import { fullListingsReceived } from '../../../listings-client/actions'
import { processAirSearchSuccessResponse } from '@mfs/client/listings-client/actions/listings/fetchData/helpers'

export const listingsHasErrored = createSlice({
  name: 'listingsHasErrored',
  initialState: false,
  reducers: {
    updateListingsHasErrored: (state, action) => action.payload,
  },
})

export const { updateListingsHasErrored } = listingsHasErrored.actions

export const listingsIsLoading = createSlice({
  name: 'listingsIsLoading',
  initialState: true,
  reducers: {
    updateListingsIsLoading: (state, action) => action.payload,
  },
})

export const { updateListingsIsLoading } = listingsIsLoading.actions

export const checkIfNotInitialLoadOfListing = createSlice({
  name: 'checkIfNotInitialLoadOfListing',
  initialState: false,
  reducers: {
    updateCheckIfNotInitialLoadOfListing: (state, action) => action.payload,
  },
})

export const { updateCheckIfNotInitialLoadOfListing } = checkIfNotInitialLoadOfListing.actions

export const listingsLoadingMessage = createSlice({
  name: 'listingsLoadingMessage',
  initialState: '',
  reducers: {
    updateListingsLoadingMessage: (state, action) => action.payload,
  },
})

export const { updateListingsLoadingMessage } = listingsLoadingMessage.actions

export const displayInfiniteScrollLoadMore = createSlice({
  name: 'displayInfiniteScrollLoadMore',
  initialState: {},
  reducers: {
    updateDisplayInfiniteScrollLoadMore: (state, action) => ({
      ...state,
      [action.payload.activeTabId]: action.payload,
    }),
  },
})

export const { updateDisplayInfiniteScrollLoadMore } = displayInfiniteScrollLoadMore.actions

export const brandReference = createSlice({
  name: 'brandReference',
  initialState: [],
  reducers: {
    updateBrandReference: (state, action) => uniqBy([...state, ...action.payload], 'brandId'),
  },
})

export const { updateBrandReference } = brandReference.actions

export const fetchedInitialListings = createSlice({
  name: 'fetchedInitialListings',
  initialState: false,
  reducers: {
    updateFetchedInitialListings: (state, action) => action.payload,
  },
})

export const { updateFetchedInitialListings } = fetchedInitialListings.actions

export const activeTabId = createSlice({
  name: 'activeTabId',
  initialState: defaultSelectedTab,
  reducers: {
    updateActiveTabId: (state, action) => action.payload,
  },
})

export const { updateActiveTabId } = activeTabId.actions

export const listings = createSlice({
  name: 'listings',
  initialState: {},
  reducers: {
    updateListingsFetchDataSuccess: (state, action) => {
      return {
        ...state,
        lastUpdateTime: new Date().getTime(),
        response: action.payload.response,
      }
    },
  },
})

export const { updateListingsFetchDataSuccess } = listings.actions

export function addFullListingsStateListeners(startListening) {
  startListening({
    actionCreator: fullListingsReceived,
    effect: (action, listenerApi) => {
      listenerApi.cancelActiveListeners()
      const state = listenerApi.getState()
      const dispatch = listenerApi.dispatch
      const res = action.payload
      processAirSearchSuccessResponse({ res, dispatch, state })
    },
  })
}

export const recommendedListings = createSlice({
  name: 'recommendedListings',
  initialState: {},
  reducers: {
    updateRecommendedListings: (state, action) => ({
      ...state,
      [action.payload.activeTabId]: action.payload.recommendedListings,
    }),
  },
})

export const { updateRecommendedListings } = recommendedListings.actions
